import styled from "@emotion/styled";
import {
  createPolymorphicComponent,
  Text,
  type TextProps,
} from "@mantine/core";
import { Link as RouterLink } from "react-router-dom";

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 25px;
  gap: 32px;

  img {
    object-fit: contain;
    width: 45%;
  }
`;

export const LoginContainer = styled.div`
  background-image: url(./assets/background.jpg);
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DarkBox = styled.div`
  padding: 0 50px;
  width: 500px;
  background-color: #2223249c;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoginFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 60%;
  height: 5%;
`;

const _FooterText = styled(Text)`
  color: white;
  font-size: 0.5rem;
  cursor: default;
`;

const _Link = styled(RouterLink)`
  color: white;
  font-size: 0.5rem;
  cursor: pointer;
`;

export const FooterText = createPolymorphicComponent<"text", TextProps>(
  _FooterText,
);

export const Link = createPolymorphicComponent<"text", TextProps>(_Link);
